import React from 'react';
import logo from '../assets/logo.png';

function Header() {
  return (
    <header className="bg-gradient-to-r from-gold-700 via-gold-500 to-gold-400 shadow-lg">
      <div className="max-w-5xl mx-auto px-6 py-4 flex flex-col items-center justify-center gap-2">
        <img src={logo} alt="Logo" className="h-14 w-auto" />
        <h1 className="text-white text-xl md:text-2xl font-bold tracking-wide text-center">
          REVISIÓN DE SOLICITUD DE AUTORIZACIÓN DE EMBARQUE
        </h1>
      </div>
    </header>
  );
}

export default Header;
